import { formatApiError } from "./apiErrors";
import { apiErrorCode } from "../../components/timetable/runErrors";

// The visit-scheduling endpoints answer a rejected booking with a field-keyed
// DRF body that ALSO carries a machine `code`. Branch on the code — never on
// the English prose, which is what every scheduling surface used to render
// straight into a Russian UI ("This teacher already has a visit that period").
//
// Same contract and same shape as components/timetable/runErrors.js; it lives
// apart only because the two vocabularies are disjoint and a merged map would
// invite reading a timetabling code off a booking response.

// code -> i18n key. Mirrors the `fail(...)` codes raised by
// observations/services/scheduling.py (apps/core/errors.py). Extend the map when the backend grows a
// code; an unmapped one still reads, because the server's prose is the fallback.
const CODE_KEYS = {
  teacher_busy: "upcoming.errTeacherBusy",
  observer_busy: "upcoming.errObserverBusy",
  period_out_of_range: "upcoming.errPeriodRange",
};

// A field's value is a list from a serializer and a bare string from a view, so
// never index it — `data.period[0]` on a string is its first CHARACTER, which is
// how an English sentence once reached the screen as "T".
const firstOf = (value) => {
  const item = Array.isArray(value) ? value[0] : value;
  return typeof item === "string" && item ? item : null;
};

/** Localized message for a rejected booking, falling back to the server's own. */
export function slotErrorMessage(err, t, fallback) {
  const key = CODE_KEYS[apiErrorCode(err)];
  if (key) return t(key);
  const data = err?.response?.data;
  return (
    firstOf(data?.period) ||
    firstOf(data?.scheduled_date) ||
    formatApiError(err, fallback)
  );
}
